import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Check if Firebase configuration is properly set
const isFirebaseConfigured = () => {
  const requiredEnvVars = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID',
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    'REACT_APP_FIREBASE_APP_ID'
  ];
  
  const result = requiredEnvVars.every(envVar => {
    const value = process.env[envVar];
    return value && value !== 'your_firebase_api_key' && !value.includes('demo') && !value.includes('Demo');
  });
  
  console.log('Firebase Configuration Check:', {
    requiredEnvVars,
    envValues: requiredEnvVars.map(envVar => ({
      [envVar]: process.env[envVar] ? 'SET' : 'MISSING'
    })),
    isConfigured: result
  });
  
  return result;
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase only if properly configured
let app = null;
let auth = null;
let db = null;
let googleProvider = null;
let githubProvider = null;

export const isFirebaseEnabled = isFirebaseConfigured();

if (isFirebaseEnabled) {
  try {
    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    // Initialize Firebase Authentication and get a reference to the service
    auth = getAuth(app);

    // Initialize Cloud Firestore and get a reference to the service
    db = getFirestore(app);

    // OAuth providers
    googleProvider = new GoogleAuthProvider();
    githubProvider = new GithubAuthProvider();

    // Configure providers
    googleProvider.setCustomParameters({
      prompt: 'select_account'
    });

    githubProvider.setCustomParameters({
      prompt: 'consent'
    });
  } catch (error) {
    console.error('Firebase initialization error:', error);
  }
} else {
  console.warn('Firebase is not properly configured. Please check your environment variables.');
}

export { auth, db, googleProvider, githubProvider };
export default app;